<template lang="pug">
  el-form.GuestForm(:model="form" :rules="rules" ref="form" :label-width="labelWidth" label-position="left")
    el-form-item(label="您的姓名" prop="name")
      el-input.bottom-line-input(v-model="form.name" placeholder="请输入您的姓名")
    el-form-item(label="您的企业" prop="company")
      el-input.bottom-line-input(v-model="form.company" placeholder="请输入您所在的企业名称")
    el-form-item(label="您的职位" prop="job")
      el-input.bottom-line-input(v-model="form.job" placeholder="请输入您的职位")
    el-form-item(label="您的手机" prop="phone")
      .bottom-line-input.phoneSet
        //el-select(v-model="form.code" placeholder="区号")
          el-option(label="+86" value="+86")
        //intl-tel-input(@excountry="codeChange" country-code="cn")
        tel-select(v-model="form.code" @excode="exCode")
        el-input(v-model="form.phone" type="tel" :maxlength="phoneMaxLength" placeholder="请输入您的手机号码")
    el-form-item(label="备注(选填)" prop="comment")
      el-input.bottom-line-input(v-model="form.comment" placeholder="备注")
    router-link.text-button.float-right.toLogin(:to="{name: 'LoginForm'}") 使用已有的账号登录
</template>

<script>
  import {mapMutations, mapState} from "vuex";
  import TelSelect from "@/components/TelSelect";
  import {isPhone} from "@/utils/utils";

  export default {
    name: "GuestForm",
    components: {TelSelect},
    props: {},
    data() {
      return {
        phoneFormat: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/,
        phoneMaxLength: 11,
        rules: {
          name: [
            {required: true, message: '姓名不能为空', trigger: 'blur'},
            {max: 9, message: '字数不超过9个字符', trigger: 'change'},
          ],
          company: [
            {required: true, message: '请填写您所在的企业名称', trigger: 'blur'},
            {max: 20, message: '字数不超过20个字符', trigger: 'change'},
          ],
          job: [
            {required: true, message: '请填写您的职位', trigger: 'blur'},
            {max: 9, message: '字数不超过9个字符', trigger: 'change'},
          ],
          phone: [
            {required: true, message: '请输入您的电话，方便我们跟您联系', trigger: 'blur'},
            // {type: 'number', message: '电话必须是数字', trigger: 'change'},
            {min: 11, message: '请输入长度为11位的电话号码', trigger: 'blur'},
            {
              validator: (rule, value, callback) => {
                if (!this.phoneFormat.test(
                  value)) {
                  return callback(new Error('手机号码格式不正确'));
                }
                callback();
              }, trigger: 'blur'
            }
          ],
          comment: [
            {max: 50, message: '字数不超过50个字符', trigger: 'change'},
          ],
        },
      };
    },
    watch: {},
    computed: {
      labelWidth() {
        if (isPhone()) {
          return '80px';
        }
        return null;
      },
      form: {
        get() {
          return this.guestForm;
        },
        set(val) {
          this.setGuestForm(val);
        }
      },
      ...mapState({
        guestForm: state => state.guestForm,
      })
    },
    methods: {
      exCode(val) { // 解析不同地区电话的格式
        console.log('exCode', val);
        const {phoneFormat} = val
      },
      ...mapMutations({
        setRef: 'setGuestRef',
        setForm: 'setGuestForm'
      })
    },
    created() {
    },
    mounted() {
      this.setRef(this.$refs['form']);
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .phoneSet {
    display flex
    align-items flex-end
    justify-content flex-start
    width 100%
    
    .el-select {
      width 20%
      
      /deep/ .el-input__inner {
        text-align center
      }
    }
  }
  
  .toLogin {
    margin-top -10px
  }
  @media (max-width screenWidth) {
    .phoneSet {
      .el-select {
        width 60px
        flex-shrink 0
      }
    }
  }
  .el-form {
    /deep/ .is-error {
      .el-input__inner {
        background-color transparent !important
      }
    }
  }

</style>
